import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import Lenis from "lenis";
import { Navbar } from "./components/Navbar";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Agents from "./pages/Agents";
import Vaults from "./pages/Vaults";
import Terminal from "./pages/Terminal";
import Market from "./pages/Market";
import Docs from "./pages/Docs";
import About from "./pages/About";
import Leaderboard from "./pages/Leaderboard";

const Page = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -8 }}
    transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Page><Home /></Page>} />
        <Route path="/agents" element={<Page><Agents /></Page>} />
        <Route path="/vaults" element={<Page><Vaults /></Page>} />
        <Route path="/terminal" element={<Page><Terminal /></Page>} />
        <Route path="/market" element={<Page><Market /></Page>} />
        <Route path="/docs" element={<Page><Docs /></Page>} />
        <Route path="/about" element={<Page><About /></Page>} />
        <Route path="/leaderboard" element={<Page><Leaderboard /></Page>} />
        <Route path="*" element={<Page><Home /></Page>} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <div className="min-h-screen bg-ink-900 font-body text-fog-100 antialiased">
        <ScrollManager />
        <Navbar />
        <AnimatedRoutes />
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
